import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
      >
        <path
          fill="#D2E4FF"
          fillOpacity=".7"
          fillRule="nonzero"
          d="M15 7.307c0 4.035-3.296 7.307-7.364 7.307a7.376 7.376 0 0 1-3.56-.91L0 15l1.33-3.92A7.23 7.23 0 0 1 .271 7.307C.272 3.27 3.57 0 7.636 0 11.704 0 15 3.271 15 7.307zM7.636 1.164c-3.414 0-6.19 2.756-6.19 6.143 0 1.344.438 2.589 1.179 3.601L1.85 13.19l2.38-.756a6.187 6.187 0 0 0 3.405 1.016c3.414 0 6.192-2.755 6.192-6.143 0-3.387-2.778-6.143-6.192-6.143zm3.719 7.826c-.046-.075-.166-.12-.346-.21-.18-.089-1.069-.522-1.234-.582-.165-.06-.286-.09-.406.09-.12.179-.466.582-.572.702-.105.12-.21.134-.39.045-.181-.09-.763-.279-1.452-.889a5.4 5.4 0 0 1-1.004-1.24c-.105-.18-.011-.276.079-.365.081-.08.18-.21.27-.314.091-.105.121-.18.181-.299.06-.12.03-.224-.015-.314s-.406-.97-.556-1.33c-.15-.357-.301-.298-.407-.298-.105 0-.225-.015-.346-.015a.666.666 0 0 0-.481.224c-.165.18-.631.613-.631 1.494s.646 1.733.737 1.852c.09.12 1.248 1.987 3.083 2.704 1.835.717 1.835.478 2.166.448.33-.03 1.068-.434 1.219-.851.15-.42.15-.778.105-.852z"
        />
      </svg>
    )
  }
}

export default IcRightArrow
